export default "__VITE_ASSET__5It5CUXm__"